module.exports = __webpack_public_path__ + "img/jc2.5b23f5b3.jpg";